// M19: 軌跡 - Locus
// 系統化數據結構，準備 Supabase 後端遷移

export const M19_MODULE_INFO = {
  moduleId: 'M19',
  title: '軌跡',
  titleEn: 'Locus',
  description: '學習動點軌跡的概念和應用',
  totalTopics: 20,
  estimatedTime: '6-8小時',
  difficulty: 'advanced',
  prerequisites: ['M04', 'M13', 'M17'],
  learningObjectives: [
    '理解軌跡的基本概念',
    '掌握各種軌跡的求法',
    '應用軌跡解決幾何問題',
    '理解參數方程與軌跡',
    '分析複雜軌跡問題'
  ]
};

export const M19_TOPICS = [
  {
    id: 'M19_01',
    name: "點到定點的等距軌跡",
    description: "動點到定點距離恆定的軌跡",
    order: 1,
    subTopics: [
      "圓的軌跡方程",
      "距離公式的應用",
      "軌跡的幾何性質",
      "軌跡與其他圖形的關係",
      "實際應用問題"
    ]
  },
  {
    id: 'M19_02',
    name: "點到兩定點等距離軌跡",
    description: "動點到兩定點距離相等的軌跡",
    order: 2,
    subTopics: [
      "垂直平分線的性質",
      "等距離軌跡方程",
      "軌跡的對稱性",
      "與其他圖形的交點",
      "綜合應用問題"
    ]
  },
  {
    id: 'M19_03',
    name: "點到定直線等距離軌跡",
    description: "動點到定直線距離恆定的軌跡",
    order: 3,
    subTopics: [
      "平行線軌跡",
      "點到直線距離公式",
      "軌跡的平移性質",
      "多條直線的等距軌跡",
      "實際問題建模"
    ]
  },
  {
    id: 'M19_04',
    name: "點到定點和定直線等距離軌跡",
    description: "拋物線的定義和性質",
    order: 4,
    subTopics: [
      "拋物線的定義",
      "焦點和準線",
      "拋物線方程推導",
      "拋物線的性質",
      "拋物線的應用"
    ]
  },
  {
    id: 'M19_05',
    name: "動點與兩定點距離之和為定值",
    description: "橢圓的定義和軌跡",
    order: 5,
    subTopics: [
      "橢圓的定義",
      "橢圓的標準方程",
      "橢圓的性質",
      "離心率概念",
      "橢圓的應用"
    ]
  },
  {
    id: 'M19_06',
    name: "動點與兩定點距離之差為定值",
    description: "雙曲線的定義和軌跡",
    order: 6,
    subTopics: [
      "雙曲線的定義",
      "雙曲線方程",
      "雙曲線的性質",
      "漸近線概念",
      "雙曲線的應用"
    ]
  },
  {
    id: 'M19_07',
    name: "動點到定點距離與到定直線距離比值為定值",
    description: "圓錐曲線的統一定義",
    order: 7,
    subTopics: [
      "離心率的統一概念",
      "圓錐曲線的分類",
      "極坐標表示",
      "統一方程形式",
      "幾何光學應用"
    ]
  },
  {
    id: 'M19_08',
    name: "動線段中點軌跡",
    description: "中點軌跡的求法和性質",
    order: 8,
    subTopics: [
      "中點公式應用",
      "軌跡的縮放性質",
      "參數方程建立",
      "軌跡的相似變換",
      "複雜中點軌跡"
    ]
  },
  {
    id: 'M19_09',
    name: "動角頂點軌跡",
    description: "角頂點變化的軌跡問題",
    order: 9,
    subTopics: [
      "圓周角定理應用",
      "同弧圓周角軌跡",
      "三角形內心軌跡",
      "角平分線性質",
      "動角的幾何軌跡"
    ]
  },
  {
    id: 'M19_10',
    name: "相切圓圓心軌跡",
    description: "與定圓相切的動圓圓心軌跡",
    order: 10,
    subTopics: [
      "內切圓心軌跡",
      "外切圓心軌跡",
      "圓的包絡線",
      "切線的性質",
      "圓族的軌跡"
    ]
  },
  {
    id: 'M19_11',
    name: "定長線段端點軌跡",
    description: "定長線段端點的運動軌跡",
    order: 11,
    subTopics: [
      "線段端點約束",
      "滑動軌跡",
      "旋轉軌跡",
      "複合運動軌跡",
      "機械運動模型"
    ]
  },
  {
    id: 'M19_12',
    name: "投影點軌跡",
    description: "點的投影軌跡分析",
    order: 12,
    subTopics: [
      "正射影概念",
      "投影軌跡方程",
      "三維投影",
      "陰影問題",
      "光學投影應用"
    ]
  },
  {
    id: 'M19_13',
    name: "反射點軌跡",
    description: "光線反射和點反射軌跡",
    order: 13,
    subTopics: [
      "反射定律應用",
      "鏡面反射軌跡",
      "多次反射",
      "反射的對稱性",
      "光學儀器原理"
    ]
  },
  {
    id: 'M19_14',
    name: "旋轉點軌跡",
    description: "點繞定點旋轉的軌跡",
    order: 14,
    subTopics: [
      "圓形旋轉軌跡",
      "旋轉變換矩陣",
      "複數表示旋轉",
      "螺線軌跡",
      "機械旋轉應用"
    ]
  },
  {
    id: 'M19_15',
    name: "參數方程軌跡",
    description: "用參數方程描述的軌跡",
    order: 15,
    subTopics: [
      "參數方程基礎",
      "消參得普通方程",
      "參數的幾何意義",
      "複雜參數軌跡",
      "參數軌跡的性質"
    ]
  },
  {
    id: 'M19_16',
    name: "極坐標軌跡",
    description: "極坐標系中的軌跡問題",
    order: 16,
    subTopics: [
      "極坐標基礎",
      "極坐標方程",
      "極坐標與直角坐標轉換",
      "玫瑰線等特殊軌跡",
      "極坐標軌跡性質"
    ]
  },
  {
    id: 'M19_17',
    name: "複數軌跡",
    description: "複平面上的軌跡問題",
    order: 17,
    subTopics: [
      "複數的幾何表示",
      "複數軌跡方程",
      "模長和輻角軌跡",
      "複數變換軌跡",
      "分式線性變換"
    ]
  },
  {
    id: 'M19_18',
    name: "向量軌跡",
    description: "向量表示的軌跡問題",
    order: 18,
    subTopics: [
      "向量軌跡方程",
      "向量的線性組合",
      "向量軌跡的性質",
      "三維向量軌跡",
      "向量場軌跡"
    ]
  },
  {
    id: 'M19_19',
    name: "函數圖像軌跡",
    description: "函數圖像作為軌跡的分析",
    order: 19,
    subTopics: [
      "函數軌跡的參數化",
      "隱函數軌跡",
      "軌跡的微分性質",
      "軌跡的積分應用",
      "函數軌跡的變換"
    ]
  },
  {
    id: 'M19_20',
    name: "條件約束軌跡",
    description: "多條件約束下的軌跡問題",
    order: 20,
    subTopics: [
      "多約束條件軌跡",
      "優化軌跡問題",
      "軌跡的交集",
      "軌跡的並集",
      "複雜約束軌跡"
    ]
  }
];

// 導出模組統計信息
export const M19_STATS = {
  totalTopics: M19_TOPICS.length,
  totalSubTopics: M19_TOPICS.reduce((sum, topic) => sum + topic.subTopics.length, 0),
  estimatedHours: 8,
  difficultyLevel: 3, // 1-3 scale
  prerequisiteModules: 3
}; 